export function sanitize(data, defaultValue = {}) {
    if (typeof data === 'object') {
        return (data ? _sanitize(data) : defaultValue) || defaultValue
    }

    return data
}

function _sanitize(data) {
    const object = Object.entries(data).reduce((data, [key, value]) => {
        if (value?.length > 0 || typeof value === 'boolean' || typeof value === 'number') {
            data[key] = value

            return data
        }

        if (value != null) {
            const object = _sanitize(value)

            if (object) {
                data[key] = object
            }
        }

        return data
    }, {})

    if (Object.keys(object).length === 0) {
        return undefined
    }

    return object
}
